import { RoomOutlined } from '@mui/icons-material';
import { Stack, Typography } from '@mui/material';
import parse from 'autosuggest-highlight/parse';

import { PlaceType } from './type';

interface OptionItemProps {
  option: PlaceType;
  props: React.HTMLAttributes<HTMLLIElement>;
}

export const OptionItem: React.FC<OptionItemProps> = ({ option, props }) => {
  const matches =
    option.structured_formatting.main_text_matched_substrings || [];

  const parts = parse(
    option.structured_formatting.main_text,
    matches.map((match) => [match.offset, match.offset + match.length]),
  );

  return (
    <li {...props}>
      <Stack gap={2} direction="row" alignItems="center">
        <RoomOutlined sx={{ color: 'text.secondary' }} />
        <>
          <Typography
            variant="body1"
            color="text.dark"
            sx={{ borderBottom: '1px solid #E5E7EB' }}
          >
            {parts.map((part) => part.text)}{' '}
            {option.structured_formatting.secondary_text}
          </Typography>
        </>
      </Stack>
    </li>
  );
};
